export default {
  title: 'Кыргызстандагы кыймылсыз мүлк',
  test: 'test',
  button: {
    advert: {
      new: 'Жаны объявление',
      complex: 'Комплексин кошуу',
      company: 'Компания кошуу'
    },
    map: 'Картада көрсөтүү',
    adverts: 'Kөрсөтүү {count} объявления'
  },
  menu: {
    link1: 'Жыртык',
    link2: 'Сатуу',
    link3: 'Жаңы менчик',
    link4: 'өнөр жайлык',
    link5: 'Ысык-Көлдө эс алуу'
  }
}
